import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogConfirmComponent implements OnInit {
  hidecancelBtn = false;
  slideControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmComponentData
  ) {}

  ngOnInit(): void {
    if (this.data.additionalBoolean) {
      this.slideControl = new FormControl(this.data.additionalBoolean.value);
    }
    if (!this.data.cancelBtn) {
      this.hidecancelBtn = !this.data.cancelBtn;
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  handleConfirm() {
    const returnValue = this.data.additionalBoolean ? { additionalBoolean: this.slideControl.value } : true;
    this.dialogRef.close(returnValue);
  }
}

export interface DialogConfirmComponentData {
  title: string;
  descriptionHtml: string;
  confirmBtn: string;
  closeIconPath?: string;
  cancelBtn?: boolean;
  additionalBoolean?: { label: string; value: boolean; type: 'slide' };
}
